import { render, staticRenderFns } from "./popover-container.vue?vue&type=template&id=e173e39a&scoped=true&"
import script from "./popover-container.vue?vue&type=script&lang=js&"
export * from "./popover-container.vue?vue&type=script&lang=js&"
import style0 from "./popover-container.vue?vue&type=style&index=0&id=e173e39a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e173e39a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e173e39a')) {
      api.createRecord('e173e39a', component.options)
    } else {
      api.reload('e173e39a', component.options)
    }
    module.hot.accept("./popover-container.vue?vue&type=template&id=e173e39a&scoped=true&", function () {
      api.rerender('e173e39a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shells/popover/popover-container.vue"
export default component.exports